import { routes } from "instanceManagement/routes";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import Sidebar from "features/layout/SidebarNav/Sidebar";
import { NavGroup } from "features/layout/SidebarNav/types";

import { RouteConfig } from "services/routesConfig";

interface Props {
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
  toggleExpand: () => void;
  routeConfig: RouteConfig;
}

const SidebarNav = ({
  expanded,
  setExpanded,
  toggleExpand,
  routeConfig,
}: Props) => {
  const navGroups: NavGroup[] = [
    {
      title: "Tenants",
      links: [
        {
          icon: HomeOutlinedIcon,
          text: "Tenants",
          to: routes.tenants,
          hasUnlistedSubroutes: true,
          testId: "nav-tenants",
        },
      ],
    },
  ];

  return (
    <Sidebar
      navGroups={navGroups}
      expanded={expanded}
      setExpanded={setExpanded}
      toggleExpand={toggleExpand}
      routeConfig={routeConfig}
    />
  );
};

export default SidebarNav;
